/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-09-26 11:39:10
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { Badge, Button, Icon, TextStyle } from '@shopify/polaris';
import { EditMinor, DuplicateMinor, ThemesMajor, ThemeEditMajor } from '@shopify/polaris-icons';
import { withI18n } from '@shopify/react-i18n';

import {
  RECOMMENDATION_WIDGET_PAGE_TYPES as PAGE_TYPES,
  RECOMMENDATION_WIDGET_RECOMMENDATION_TYPES as RECOMMENDATION_TYPES
} from 'src/constants/recommendation';
import { showSABToast } from 'src/integrations/shopify-app-bridge/toast';

import type { RecommendationWidgetType } from 'src/models/recommendation';

type Props = {
  widget: RecommendationWidgetType,
  currentSection: number,
  updateCurrentSection: Function
};

type ComposedProps = Props & WithI18nProps;

class SettingsHeading extends Component<ComposedProps> {
  render() {
    const { i18n, widget, currentSection, updateCurrentSection } = this.props;

    const { recommendationType, pageType, id: widgetId } = widget;

    const pageTypeName = _.get(PAGE_TYPES, `${pageType}.name`, '');
    const recommendationTypeName = _.get(RECOMMENDATION_TYPES, `${recommendationType}.name`, '');
    return (
      <div className="visual-editor-settings">
        <div className="card-section title-bold-normal">
          <div className="title-line word-break">
            <Icon source={EditMinor} color="subdued" />
            <TextStyle variation="subdued">
              {i18n.translate('AdminHTML.Recommendation.WidgetItem.design_Label')}
            </TextStyle>
          </div>
        </div>
        {/* Widget layout settings */}
        <div className="card-section">
          <div className="sub-title">
            <Badge>{pageTypeName ? i18n.translate(pageTypeName) : pageType}</Badge>
            <Badge>
              {recommendationTypeName ? i18n.translate(recommendationTypeName) : recommendationType}
            </Badge>
          </div>

          {!_.isEmpty(widgetId) && (
            <div className="widget-id">
              <TextStyle variation="subdued">
                {i18n.translate('AdminHTML.Recommendation.WidgetItem.widgetId_Label', {
                  nt_widgetId: widgetId,
                  nt_buttonCopy: (
                    <span className="copy">
                      <Button
                        icon={DuplicateMinor}
                        plain
                        onClick={() => this.copyClipBoard(widgetId)}
                      />
                    </span>
                  )
                })}
              </TextStyle>
            </div>
          )}

          <div className="edit-sections">
            <div className={`btn-section ${currentSection === 0 ? 'active' : ''}`}>
              <Button
                plain
                monochrome
                textAlign="left"
                fullWidth
                icon={ThemesMajor}
                onClick={() => updateCurrentSection(0)}>
                {i18n.translate('AdminHTML.Recommendation.VisualEditor.cardSection02_Title')}
              </Button>
            </div>
            <div className={`btn-section ${currentSection === 1 ? 'active' : ''}`}>
              <Button
                plain
                monochrome
                textAlign="left"
                fullWidth
                icon={ThemeEditMajor}
                onClick={() => updateCurrentSection(1)}>
                {i18n.translate('AdminHTML.Recommendation.VisualEditor.cardSection03_Title')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  copyClipBoard = (copyText: string) => {
    const { i18n } = this.props;
    try {
      const inputText = document.createElement('input');
      inputText.value = copyText;
      document.body.appendChild(inputText);
      inputText.select();

      document.execCommand('copy');
      document.body.removeChild(inputText);
      showSABToast(i18n.translate('AdminHTML.Common.Action.copied', { t: copyText }), false);
    } catch (error) {}
  };
}

export default withI18n()(SettingsHeading);
